import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { MOCKUP_IMAGE } from '../lib/constants';
const stats = [{
  value: '+300',
  label: 'Páginas listas para usar'
}, {
  value: '6',
  label: 'Tomos digitales'
}, {
  value: '100+',
  label: 'Horas recuperadas al año'
}, {
  value: '2 min',
  label: 'Para decidir qué tejer'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-138" data-mp="12a0l5b5wm0um">
      {/* soft decorative blobs */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-64 w-64 rounded-full bg-mauve-soft/40 blur-3xl" data-id="element-139" data-mp="xa4h5bx7i9f2" />
      <div className="pointer-events-none absolute -right-20 top-40 h-56 w-56 rounded-full bg-sage-light/30 blur-3xl" data-id="element-140" data-mp="s9zybf8tt2lo" />

      <div className="relative mx-auto max-w-3xl px-4 pt-8 text-center sm:pt-12" data-id="element-141" data-mp="nbyid36p5jef">
        <p className="font-display text-xl font-semibold text-plum sm:text-2xl" data-id="element-142" data-mp="3d2bmnxfzddz8">
          Karito Educa
        </p>

        <h1 className="mt-4 font-display text-[2rem] font-black leading-[1.05] tracking-tight text-plum-deep sm:text-5xl" data-id="element-143" data-mp="3814c5qmge0ov">
          Nunca vuelvas a perder una hora buscando qué tejer.{' '}
          <span className="text-mauve italic" data-id="element-144" data-mp="3o73qeex4209n">
            Descubre tu próximo proyecto en solo 2 minutos.
          </span>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-plum/80 sm:text-lg" data-id="element-145" data-mp="3e9fqzbok84l5">
          Más de <strong className="text-plum" data-id="element-146" data-mp="30ib0az366mmy">5.000 tejedoras</strong> ya
          descubrieron una forma más fácil de decidir qué tejer. Deja de perder
          tiempo buscando ideas y vuelve a disfrutar cada puntada con el Sistema
          Inteligente <strong className="text-plum" data-id="element-147" data-mp="2ql69glydq2zt">¿Qué Tejo Hoy?™</strong>
        </p>

        {/* Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="mt-8" data-id="element-148" data-mp="2vjq02znx42yi">
          <img src={MOCKUP_IMAGE} alt="Sistema ¿Qué Tejo Hoy? — 6 tomos digitales y 5 bonos" className="mx-auto w-full max-w-lg animate-floaty drop-shadow-2xl" data-id="element-149" data-mp="2ll0fv08ju6f3" />
        </motion.div>

        {/* CTA */}
        <div id="hero-cta" className="mx-auto mt-6 max-w-md" data-id="element-150" data-mp="n98dxp26z7of">
          <CtaButton data-id="element-151" data-mp="id03goyxw2nl" />
          <p className="mt-3 text-xs font-semibold text-plum/70 sm:text-sm" data-id="element-152" data-mp="ichwoyeni61f">
            Descarga inmediata · Sin suscripción · Acceso de por vida · Garantía
            de 7 días
          </p>
        </div>
      </div>

      {/* Stats bar */}
      <div className="mt-10 w-full border-t border-mauve-soft/50 bg-white" data-id="element-153" data-mp="1622kpvpnvthk">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-y-6 px-4 py-8 sm:grid-cols-4" data-id="element-154" data-mp="15zzw9g45q8ey">
          {stats.map((s, i) => <div key={s.label} className={`flex flex-col items-center px-2 text-center ${i > 0 ? 'sm:border-l sm:border-mauve-soft/40' : ''}`} data-id="element-155" data-mp="x1nxurx1u6by" data-mpi={i}>
              <span className="font-display text-3xl font-black text-mauve sm:text-4xl" data-id="element-156" data-mp="3hqagqilkozhv">
                {s.value}
              </span>
              <span className="mt-1 text-xs font-semibold uppercase tracking-wide text-plum/70 sm:text-sm" data-id="element-157" data-mp="1x7853o1s1ru4">
                {s.label}
              </span>
            </div>)}
        </div>
      </div>
    </header>;
}